import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { yieldLazyLoad } from "@devowl-wp/react-utils";
import { extendBlockerBodyStylesheet } from "@devowl-wp/web-cookie-banner";
import { useBlocker } from "../../../contexts/blocker.js";
import { useBlockerMissingServices } from "../../../hooks/blocker/useBlockerMissingServices.js";
import { useBlockerStylesheet } from "../../../hooks/blocker/useBlockerStylesheet.js";
import { useCommonTeachings } from "../../../hooks/common/useTeachings.js";
import { useA11yId } from "../../../hooks/useA11yId.js";
import { BodyDescription } from "../../common/body/description.js";
import { Button } from "../../common/button.js";
const Cookie = yieldLazyLoad(import(/* webpackChunkName: "banner-lazy", webpackMode: "lazy-once" */ "../../common/groups/cookie.js").then(({ Cookie })=>Cookie));
const BlockerBody = ()=>{
    const { Container, CookieScroll, a11yIds: { firstButton } } = useBlockerStylesheet().extend(...extendBlockerBodyStylesheet);
    const blocker = useBlocker();
    const a11yCookieList = useA11yId();
    const [areCookiesVisible, setCookiesVisible] = useState(false);
    const { texts: { blockerLoadButton, blockerLinkShowMissing, blockerAcceptInfo }, onUnblock, productionNotice, isConsentRecord, i18n: { close } } = blocker;
    const missing = useBlockerMissingServices();
    const { description, teachings } = useCommonTeachings({
        services: missing,
        // Not needed in blocker, as there is already a link with "Show all services which I need to consent to"
        disableListServicesNotice: true,
        disableTcfPurposes: true
    });
    return /*#__PURE__*/ _jsx(Container, {
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(BodyDescription, {
                    description: description,
                    teachings: [
                        ...teachings,
                        blockerAcceptInfo
                    ],
                    nl2br: true
                }),
                /*#__PURE__*/ _jsx(Button, {
                    id: firstButton,
                    type: "acceptIndividual",
                    onClick: ()=>setCookiesVisible(!areCookiesVisible),
                    forceShow: true,
                    busyOnClick: false,
                    "aria-expanded": areCookiesVisible,
                    "aria-controls": a11yCookieList,
                    children: areCookiesVisible ? close : blockerLinkShowMissing
                }),
                /*#__PURE__*/ _jsx(CookieScroll, {
                    children: areCookiesVisible && missing.map((cookie)=>/*#__PURE__*/ _jsx(Cookie, {
                            cookie: cookie,
                            checked: true,
                            disabled: true
                        }, cookie.id))
                }),
                /*#__PURE__*/ _jsx(Button, {
                    type: "acceptAll",
                    onClick: (e)=>onUnblock(e),
                    forceShow: true,
                    sticky: true,
                    busyOnClick: !isConsentRecord,
                    children: blockerLoadButton
                }),
                productionNotice
            ]
        })
    });
};
export { BlockerBody };
